import {Trans, useTranslation} from '@/translations/i18n.tsx'
import {useMe} from '@features/user/queries/useMe.ts'
import {raise} from '@utilities/helpers.ts'
import {useEffect, useState} from 'react'
import {CategoryCard} from './category-card'
import {AirbnbIcon} from '@components/ui/icon'
import {Button} from '@components/ui/button'
import {ChangeAccountModal} from './change-account-modal'
import {ConfirmAccountModal} from './confirm-account-modal'
import {useParsedSearchParams} from '@hooks/useParsedSearchParams'
import {z} from 'zod'
import {SETTINGS_SECTION_WRAPPER_CLASSNAME} from '@features/settings/constants.ts'

export const LinkAirbnbAccountSection = () => {
    const {t} = useTranslation()
    const {searchParams, setSearchParams} = useParsedSearchParams(
        z.object({isConfirmAccount: z.enum(['true', 'false']).transform(value => value == 'true')}).partial()
    )
    const userMeQuery = useMe({throwOnError: true})
    const user = userMeQuery.data ?? raise('user is nullish')
    const [isChangeAccountModalOpen, setIsChangeAccountModalOpen] = useState(false)
    const [isConfirmAccountModalOpen, setIsConfirmAccountModalOpen] = useState(false)

    const isSSOConfigured = user.isAirbnbSsoConfigured
    const isSSOActive = user.isAirbnbSsoActive

    useEffect(() => {
        if (searchParams.isConfirmAccount) {
            setIsConfirmAccountModalOpen(true)
        }
    }, [searchParams.isConfirmAccount])

    return (
        <>
            <div className={SETTINGS_SECTION_WRAPPER_CLASSNAME}>
                <CategoryCard
                    icon={AirbnbIcon}
                    title={t('settings:link_airbnb_account:title')}
                    description={t('settings:link_airbnb_account:description')}
                />

                <div className="flex flex-col gap-2 [&_p]:text-neutral-700 [&_span]:text-sm [&_span]:text-neutral-700 items-start">
                    <AirbnbIcon fill="#EB4C60" />
                    <div className="flex flex-col gap-1">
                        <p>
                            <Trans
                                i18nKey={
                                    isSSOConfigured && isSSOActive
                                        ? 'settings:link_airbnb_account:linked_account'
                                        : 'settings:link_airbnb_account:not_connected_account'
                                }
                                components={{strong: <strong />}}
                                values={{email: user.airbnbEmail}}
                            />
                        </p>
                        <span>{t('settings:link_airbnb_account:link_account_description')}</span>
                    </div>
                    {(!isSSOConfigured || !isSSOActive) && (
                        <Button variant="tertiary" shape="text" onClick={() => setIsChangeAccountModalOpen(true)}>
                            {t('settings:link_airbnb_account:connect_account')}
                        </Button>
                    )}
                </div>
            </div>

            {isChangeAccountModalOpen && <ChangeAccountModal onClose={() => setIsChangeAccountModalOpen(false)} />}

            {isConfirmAccountModalOpen && (
                <ConfirmAccountModal
                    handleOpenChangeAccount={() => setIsChangeAccountModalOpen(true)}
                    onClose={() => {
                        setIsConfirmAccountModalOpen(false)
                        setSearchParams({isConfirmAccount: undefined})
                    }}
                />
            )}
        </>
    )
}
